module.exports = __webpack_public_path__ + "img/img4.edebc515.svg";